import React, { PureComponent } from 'react';
import { bool, func, object } from 'prop-types';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MomentUtils from '@date-io/moment';
import { Calendar, MuiPickersUtilsProvider } from 'material-ui-pickers';
import { dateHasOpenHours } from '../../core/util/location';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';

const theme = createMuiTheme({
  typography: { useNextVariants: true },
  overrides: {
    MuiTypography: {
      alignCenter: {
        fontFamily: fontFamily.bold,
        fontSize: fontSize.medium,
        letterSpacing: '-0.18px',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        marginTop: 0,
      },
      dayLabel: {
        color: colors.lightText,
        fontFamily: fontFamily.book,
        letterSpacing: '-0.12px',
        fontSize: fontSize.small,
      },
    },
    MuiPickersDay: {
      day: {
        color: colors.myRightFoot,
        fontFamily: fontFamily.medium,
      },
      isSelected: {
        backgroundColor: colors.crunchBerry,
        '&:hover': {
          backgroundColor: colors.crunchBerry,
        },
      },
      current: {
        fontFamily: fontFamily.bold,
        color: colors.crunchBerry,
      },
      isDisabled: {
        color: colors.greyWorm,
      },
    },
  },
});

export default class SolvCalendar extends PureComponent {
  static propTypes = {
    handleDateChange: func.isRequired,
    selectedDate: object.isRequired,
    location: object,
  };

  isDateDisabled = date => this.props.location && !dateHasOpenHours(this.props.location, date);

  render() {
    const { selectedDate, handleDateChange } = this.props;

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <MuiThemeProvider theme={theme}>
          <Calendar
            date={selectedDate}
            onChange={handleDateChange}
            shouldDisableDate={this.isDateDisabled}
            disablePast
          />
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    );
  }
}
